import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const EmailChangeConfirmationPage = lazyWithRetry(() => import("@/features/emailChange/pages/EmailChangeConfirmationPage"));

// The mailed link carries the token in the fragment (`/email/confirmation#<token>`), see useConfirmationToken.
export const EMAIL_CHANGE_CONFIRMATION_PATH = "/email/confirmation";

const emailChangeRoutes: RouteConfig[] = [
  {
    path: EMAIL_CHANGE_CONFIRMATION_PATH,
    element: <EmailChangeConfirmationPage />,
    isProtected: false,
    useMainLayout: false,
  },
];

export default emailChangeRoutes;
